import React from "react";

/** Animated placeholder block (shimmer). */
function CmsShimmer({ className = "", style, as: Tag = "span" }) {
  return (
    <Tag
      className={`cms-shimmer${className ? ` ${className}` : ""}`}
      style={style}
      aria-hidden="true"
    />
  );
}

export default CmsShimmer;
